import React from 'react'
import TypeColorItemContainer from './TypeColorItemContainer'

const TypeColorItem = props => (
  <TypeColorItemContainer data-test="component-configurator-type-color-item" {...props} />
)

export default TypeColorItem
